module.exports = __webpack_public_path__ + "static/media/Shares.ae4bab76.svg";